import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Typography } from "@material-ui/core/";
import TextField from "@material-ui/core/TextField";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Select from '@material-ui/core/Select';
import MenuItem from "@material-ui/core/MenuItem";  
import FormControl from '@material-ui/core/FormControl';
import Autocomplete from "@material-ui/lab/Autocomplete";
import Icon from "@material-ui/core/Icon";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from 'moment'
// import "../Dashboard/input.css";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "transparent",
    padding: "0px 5px 5px 5px",
    margin: 5,
  },
  typography: {
    fontSize: 13,
    fontWeight: "bold",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(0),
  },
  input: {
    padding: 0,
  },
  formControl:{
    width:'100%',
  }
}));

export const SearchBar = ({
  value,
  handleSideBarChange,  
  handleSideBarSubmit,
  companies,
  packageDetails,
  btnLoader,
  setBtnLoader,
  selectedCompany,
  setSelectedCompany,
}) => {
  const {t} = useTranslation();
  let language = useSelector((state) => state.languageReducer.language);
  const classes = useStyles();
  let company = useSelector((state) => state.companyReducer.company);
  console.log(
    packageDetails?.data?.id !== "09b7b809-3f45-4439-9836-ba91b160174d"
      ? new Date(new Date(new Date().getFullYear(), new Date().getMonth(), 1))
      : null
  );


  const startDate = moment(value.end).subtract(3,"months");
  const endDate = moment(value.start).add(3,"months");


  console.log("COMPANIES IN FILTER <<<<<<>>>>>>>>>>", companies);

  return <div className={classes.root}>
      <p className="filterHeading" style={{ color: "#306086", justifyContent: "center", display: "flex", fontSize: 20, fontWeight:'bold',marginTop:0 }}>
        {t("Search & Filters")}
      </p>
      <Grid spacing={2} alignItems="center " justify="center">
        <Grid style={{ display: "flex", justifyContent: "center", flexDirection: "column" }}>
          <Grid item xs={12} md={8} sm={12} style={{ alignSelf: "center" }}>
            <div style={{ flexDirection: "row", display: "flex", justifyContent: "space-between" }}>
              <div className={classes.typography} style={{ color: "#19123e" }}>
              <p className="filterHeading" style={{ color: "#306086", justifyContent: (language == "ar" ? "right" :"left"), display: "flex", fontSize: 14, fontWeight:'bold',marginTop:0,marginBottom:0 }}>
        {t("From")}
      </p>
                <MuiPickersUtilsProvider utils={DateFnsUtils} classes={{ input: classes.input }}>
                  <KeyboardDatePicker disableToolbar disableFuture minDate={startDate} format="MM/dd/yyyy" id="date-picker-inline" value={value.from //variant="dialog" //className={classes.textField}
                    } InputProps={{ disableUnderline: true }} onChange={(e) => handleSideBarChange(
                        { target: { name: "from", value: e } }
                      )} KeyboardButtonProps={{ "aria-label": "change date" }} keyboardIcon={<Icon style={{ color: "#0b79b6", fontSize: 25, alignSelf: "center", height: 35 }}>
                        date_range
                      </Icon>} fullWidth /> 

                  {/* // minDate={
                    //   packageDetails?.data?.id !==
                    //   "09b7b809-3f45-4439-9836-ba91b160174d"
                    //     ? new Date(
                    //         new Date(
                    //           new Date().getFullYear(),
                    //           new Date().getMonth(),
                    //           1
                    //         )
                    //       )
                    //     : undefined
                    // } */}
                </MuiPickersUtilsProvider>
              </div>

              <div className={classes.typography} style={{ color: "#19123e", marginLeft: 20 }}>
              <p className="filterHeading" style={{ color: "#306086", justifyContent: (language == "ar" ? "right" :"left"), display: "flex", fontSize: 14, fontWeight:'bold',marginTop:0,marginBottom:0 }}>
        {t("End")}
      </p>
                <MuiPickersUtilsProvider utils={DateFnsUtils} classes={{ input: classes.input }}>
                  <KeyboardDatePicker disableToolbar disableFuture maxDate={endDate} format="MM/dd/yyyy" id="date-picker-inline" value={value.end //variant="inline" // margin="normal"
                    } InputProps={{ disableUnderline: true }} onChange={(e) => handleSideBarChange(
                        { target: { name: "end", value: e } }
                      )} className={classes.textField} KeyboardButtonProps={{ "aria-label": "change date" }} fullWidth keyboardIcon={<Icon style={{ color: "#0b79b6", fontSize: 25, alignSelf: "center", height: 35 }}>
                        date_range
                      </Icon>} />
                </MuiPickersUtilsProvider>
              </div>
            </div>
          </Grid>

          {/* <Grid container item xs={12}  md={8} sm={12} style={{alignSelf:'center'}} >
            <div className={classes.typography} style={{color:'#19123e'}}>
              Template
              <Autocomplete
                id="templated-design"
                style={{ display: "inline-block",width:375 }}
                options={templates}
                getOptionLabel={(option) => option.title}
                renderOption={(option) => (
                  <React.Fragment>{option.title}</React.Fragment>
                )}
                //freeSolo
                onChange={(e, value) =>
                  handleSideBarChange({
                    target: { name: "template_id", value: value },
                  })
                }
                value={value.template_id || ""}
                renderInput={(params) => <TextField {...params}  variant="outlined"  />}
                fullWidth
              />
            </div>
          </Grid>

          <Grid container item xs={12}  md={8} sm={12} style={{alignSelf:'center'}}>
            <div className={classes.typography} style={{color:'#19123e'}}>
              Inspection
              <Autocomplete
                id="templated-design"
                style={{ display: "inline-block" ,width:375}}
                options={inspections}
                getOptionLabel={(option) => option.title}
                renderOption={(option) => (
                  <React.Fragment>{option.title}</React.Fragment>
                )}
                //freeSolo
                onChange={(e, value) =>
                  handleSideBarChange({
                    target: { name: "schedule_id", value: value },
                  })
                }
                value={value.schedule_id || ""}
                renderInput={(params) => <TextField {...params} variant="outlined"/>}
                fullWidth
              />
            </div>
          </Grid>*/}

          {/* <Grid container item xs={12} md={8} sm={12} style={{ alignSelf: "center" }}>
            <div className={classes.typography} style={{ color: "#19123e" }}>
              Company
              <Autocomplete id="templated-design" style={{ display: "inline-block", width: 375 }} options={companies} getOptionLabel={(option) => option.company_name} renderOption={(option) => <React.Fragment>
                    {option.company_name}
                  </React.Fragment>} onChange={(e, value) => handleSideBarChange( //freeSolo
                    {
                      target: { name: "company_id", value: value.id },
                    }
                  )} value={value.company_id || ""} renderInput={(params) => <TextField {...params} variant="outlined" />} fullWidth />
            </div>
          </Grid> */}

          <Grid container item xs={12} md={8} sm={12} style={{ alignSelf: "center", padding:'10px 0px',marginTop:'10px' }}>
            {companies &&<> <p className="filterHeading" style={{ color: "#306086", justifyContent: "left", display: "flex", fontSize: 14, fontWeight:'bold',marginTop:0,marginBottom:0 }}>
        {t("Select Company")}
      </p> <FormControl variant="outlined" className="companySelectorF" style={{width:'100%',textAlign:'left'}}>
                <Select  style={{width:'100%', backgroundColor:'white', padding:"5px", border:'none', borderRadius:'10px', textAlign:"left"}} labelId="demo-simple-select-outlined-label" id="demo-simple-select-outlined" onChange={(e) => setSelectedCompany(e.target.value)} size="small" fullWidth className={"companySelector"} value={selectedCompany}>
                  {companies.map((item, index) => {
                    return <MenuItem value={item.id}>
                        {item.company_name}
                      </MenuItem>;
                  })}
                </Select>
              </FormControl></>}
          </Grid>
        </Grid>

        <Grid item xs={12} md={12} sm={12} align="center" style={{ marginTop: 10, alignSelf: "center" }}>
          <Button variant="contained" color="primary"  className="addBtn" style={{  width: 200 }} onClick={() => {
              if (btnLoader === false) {
                setBtnLoader(true);
                handleSideBarSubmit(null);
              }
            }}>
            {btnLoader === true && <CircularProgress size={18} style={{ color: "white", marginRight: 7 }} />}
            Apply
          </Button>
        </Grid>
      </Grid>
    </div>;
};
